import { render, staticRenderFns } from "./AllPeople.vue?vue&type=template&id=c0c968d0&"
import script from "./AllPeople.vue?vue&type=script&lang=js&"
export * from "./AllPeople.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports